import { atom } from 'jotai';

export type DrawerType = 'details' | 'bulk-edit';

/** Controls whether the equipment drawer is open */
export const drawerIsOpenAtom = atom(false);
drawerIsOpenAtom.debugLabel = 'EquipmentDrawerState.drawerIsOpenAtom';

/** Tracks which drawer type is currently active */
export const drawerTypeAtom = atom<DrawerType | undefined>(undefined);
drawerTypeAtom.debugLabel = 'EquipmentDrawerState.drawerTypeAtom';
